import Root from "./Root";
import ReactDOM from "react-dom";
import { StrictMode } from "react";

ReactDOM.render(
  <StrictMode>
    <Root />
  </StrictMode>,
  document.getElementById("root")
);
